// extracted by mini-css-extract-plugin
export var assigneeBadge = "_j8-0";
export var assigneeDetails = "_j8-1";
export var assigneeInfo = "_j8-2";
export var dropdownContainer = "_j8-4";
export var dropdownImage = "_j8-5";
export var editAssigneeInfo = "_j8-3";
export var editAssigneeModalContainer = "_j8-6";
export var hidden = "_j8-8";
export var input = "_j8-7";